import { useAtomValue, useSetAtom } from "jotai";
import Script from "next/script";

import { GTMReadyState, sequentialLoadingState } from "~/atoms/sequential-loading";
import * as TrackingScripts from "~/components/tracking/tracking-scripts";

export default function GTMIntegration() {
  const sequentialLoadingReady = useAtomValue(GTMReadyState);
  const setGTMLoaded = useSetAtom(sequentialLoadingState);

  return sequentialLoadingReady ? (
    <>
      {process.env.NEXT_PUBLIC_TRACKING_GTM_ID && sequentialLoadingReady ? <TrackingScripts.gtmNoScript /> : null}
      {process.env.NEXT_PUBLIC_TRACKING_GTM_ID && sequentialLoadingReady ? (
        <Script id="gtm-init" onReady={() => setGTMLoaded((current) => ({ ...current, GTM: true }))}>
          {TrackingScripts.script}
        </Script>
      ) : null}
    </>
  ) : null;
}
